var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.2147 11.0083C13.2147 8.47395 15.2857 6.40291 17.82 6.40291V5.53089V0.571289H3.07746C1.71493 0.571289 0.597656 1.68856 0.597656 3.05109V21.4452C0.597656 20.0827 1.71493 18.9654 3.07746 18.9654H17.82V15.6136C15.2857 15.6136 13.2147 13.5426 13.2147 11.0083Z",
    fill: "#4D6996"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.8219 24.5258H3.07931C1.38978 24.5258 0 23.1633 0 21.4465C0 19.7297 1.36253 18.3672 3.07931 18.3672H17.8219C18.1489 18.3672 18.3941 18.6124 18.3941 18.9394V23.9263C18.3941 24.2806 18.1489 24.5258 17.8219 24.5258ZM3.07931 19.539C2.01654 19.539 1.17177 20.411 1.17177 21.4465C1.17177 22.482 2.04379 23.354 3.07931 23.354H17.2496V19.539H3.07931Z",
    fill: "#4D6996"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0.572262 22.0457C0.245255 22.0457 0 21.8004 0 21.4734V3.07931C0 1.36253 1.38978 0 3.07931 0H17.8219C18.1489 0 18.3941 0.245255 18.3941 0.572262V6.40388C18.3941 6.73089 18.1489 6.97614 17.8219 6.97614C15.6146 6.97614 13.7888 8.77468 13.7888 11.0092C13.7888 13.2438 15.5873 15.0423 17.8219 15.0423C18.1489 15.0423 18.3941 15.2876 18.3941 15.6146V18.9664C18.3941 19.2934 18.1489 19.5387 17.8219 19.5387H3.07931C2.01654 19.5387 1.17177 20.4107 1.17177 21.4462C1.14452 21.7732 0.899268 22.0457 0.572262 22.0457ZM3.07931 1.14452C2.01654 1.14452 1.17177 2.01654 1.17177 3.05206V19.0754C1.68953 18.6666 2.3708 18.3941 3.07931 18.3941H17.2496V16.1596C14.6608 15.8598 12.6443 13.6798 12.6443 11.0092C12.6443 8.33867 14.6608 6.15863 17.2496 5.85887V1.14452H3.07931Z",
    fill: "#4D6996"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.8241 16.1872C14.9628 16.1872 12.6465 13.8709 12.6465 11.0096C12.6465 8.14833 14.9628 5.83203 17.8241 5.83203C20.6854 5.83203 23.0017 8.14833 23.0017 11.0096C23.0017 13.8709 20.6854 16.1872 17.8241 16.1872ZM17.8241 7.00381C15.6168 7.00381 13.791 8.80234 13.791 11.0369C13.791 13.2714 15.5895 15.07 17.8241 15.07C20.0586 15.07 21.8572 13.2442 21.8572 11.0096C21.8572 8.77509 20.0314 7.00381 17.8241 7.00381Z",
    fill: "#4D6996"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.8203 13.7341C17.4933 13.7341 17.248 13.4888 17.248 13.1618V10.791C17.248 10.464 17.4933 10.2188 17.8203 10.2188C18.1473 10.2188 18.3926 10.464 18.3926 10.791V13.1618C18.3926 13.4888 18.1473 13.7341 17.8203 13.7341Z",
    fill: "#4D6996"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.8203 9.67382C18.1364 9.67382 18.3926 9.41761 18.3926 9.10156C18.3926 8.78551 18.1364 8.5293 17.8203 8.5293C17.5043 8.5293 17.248 8.78551 17.248 9.10156C17.248 9.41761 17.5043 9.67382 17.8203 9.67382Z",
    fill: "#4D6996"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp);
export default __webpack_public_path__ + "static/media/icon-help.03f36bb64a3ba0252cec814df1b6dd09.svg";
export { ForwardRef as ReactComponent };